import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import "./theme/tailwind.css";
import configureStore from "data/store/configureStore";
import StandAloneButtonContainer from 'ui/my_account_button/containers/StandAloneButtonContainer';
import {createBrowserRouter, RouterProvider} from "react-router-dom";
import i18n from "./i18n";
import moment from "moment";
import RollbarErrorHandler from "ui/shared/components/RollbarErrorHandler";

const AppRouter = createBrowserRouter([
    {
        path: "/:locale/",
        loader: ({ params }) => {
            if (params.locale) {
                return i18nLoader(params.locale);
            }
        },
        children: [
            {
                path: "*",
            },
        ],
        element: <StandAloneButtonContainer />,
        errorElement: <RollbarErrorHandler />
    }
]);

const store = configureStore();

const accountButtonContainer = document.getElementById('my-account-button-app');

if (accountButtonContainer !== null) {
    const accountButton = createRoot(accountButtonContainer);
    accountButton.render(<Provider store={store}>
        <RouterProvider router={AppRouter} />
    </Provider>)
}

function i18nLoader(locale) {
    moment.locale(locale);
    return i18n.changeLanguage(locale);
}


